import { DTConsumer_Private } from '@rabbit/data/types';

type ProfileCompletionInput = {
  consumerPrivate?: DTConsumer_Private | null;
  config: any;
  tenantLink: string;
};

// Terms last update is used to gate profile completion prompts until terms are accepted
export const TERMS_LAST_UPDATE_DATE = new Date('2022-09-01').getTime();

export const getProfileCompletionStatus = ({
  consumerPrivate,
  config,
  tenantLink,
}: ProfileCompletionInput) => {
  const phoneRequired = config?.CUSTOMER?.COMPLETE_PROFILE?.PHONE_NUMBER_REQUIRED;
  const ageRequired = config?.CUSTOMER?.COMPLETE_PROFILE?.AGE_BRACKET_REQUIRED;
  const profilePromptEnabled =
    config?.CUSTOMER?.COMPLETE_PROFILE?.PROFILE_PROMPT_ENABLED ?? false;

  const phoneMissing = phoneRequired && !consumerPrivate?.phone;
  const ageMissing = ageRequired && !consumerPrivate?.age_bracket;

  const termsPending =
    (consumerPrivate?.acceptedTerms ?? 0) < TERMS_LAST_UPDATE_DATE;

  const shouldPromptProfile =
    profilePromptEnabled && (phoneMissing || ageMissing) && !termsPending;

  return {
    phoneRequired,
    ageRequired,
    profilePromptEnabled,
    phoneMissing,
    ageMissing,
    termsPending,
    shouldPromptProfile,
  };
};

